import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { SIGNED_OUT_REASON_KEY } from '../api';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  // If we were sent here because a session ended, say so. Read once and
  // cleared straight away, so it explains this arrival and nothing later.
  useEffect(() => {
    try {
      const reason = sessionStorage.getItem(SIGNED_OUT_REASON_KEY);
      if (reason) {
        setNotice(reason);
        sessionStorage.removeItem(SIGNED_OUT_REASON_KEY);
      }
    } catch {
      // Storage blocked. The login form still works, there is just no note.
    }
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <h1>City of Preston Basketball</h1>
        <p className="muted">Coach portal</p>
        {notice && !error && <div className="notice-msg">{notice}</div>}
        {error && <div className="error-msg">{error}</div>}
        {/* The id, name and autoComplete attributes on these two are what let
            Chrome and the other password managers recognise this as a sign-in
            and offer to save and fill it. Without them a coach on a phone in a
            sports hall is typing their password out every single time. The
            change-password form on the profile page is already marked up this
            way; this one had been missed. Never put autoComplete="off" on
            either of them. */}
        <form onSubmit={submit}>
          <div className="form-row">
            <label htmlFor="login-email">Email</label>
            <input
              id="login-email"
              name="email"
              type="email"
              autoComplete="username"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div>
          <div className="form-row">
            <label htmlFor="login-password">Password</label>
            <input
              id="login-password"
              name="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>
          <button className="btn" type="submit" disabled={loading} style={{ width: '100%' }}>
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
        {/* Outside the form on purpose. A link inside a form is fine in HTML but
            this one is the thing a coach reaches for when the form has just
            failed them, and it reads better sat under the button than beside it. */}
        <p className="muted" style={{ textAlign: 'center', marginTop: '1rem', marginBottom: 0 }}>
          <Link to="/forgot-password">Forgotten your password?</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
